import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';
import { DEFAULT_INVALID_VALUE } from '../../../utilities/FormattingUtilities';

const _ = require('lodash');

/**
 * Parse a testAgent mapping to produce a human-friendly string describing the mapped Pulses.
 * @param info
 * @param isReturnObject
 * @param threshold
 * @returns {*}
 */
export function testAgentsParser(info, isReturnObject, threshold = 1) {
    if (!_.isObject(info)) {
        return DEFAULT_INVALID_VALUE;
    }

    if (info.all) {
        return isReturnObject === true ? { agentText: i18n._(t`All nPoints`) } : i18n._(t`All nPoints`);
    }

    const agents = _.get(info, 'populated', []);
    const tags = _.get(info, 'tags', []);
    if (agents.length > 0) {
        // Get all the Agents referenced in this mapping
        return isReturnObject === true ? produceAgentObject(agents, threshold) : produceAgentString(agents, threshold);
    }
    if (tags.length > 0) {
        return isReturnObject === true ? produceTaggedAgentsObject(tags) : i18n._(t`Tagged nPoints`);
    }

    // No selected agents or tags, so return an empty string.
    return isReturnObject === true ? { agentText: DEFAULT_INVALID_VALUE } : DEFAULT_INVALID_VALUE;
}

/**
 * Produce an Agent string from an agent object
 * @param agents
 * @return {*}
 */
function produceAgentString(agents, threshold) {
    agents = _.compact(agents);
    const num = _.size(agents);
    if (num === 0) {
        return 'No nPoints';
    }
    const names = cleanAgents(agents);

    return num > threshold ? i18n._(t`Selected ${num} nPoints`) : names;
}

/**
 * Used by the grids to return an object that is used to create
 *   a lodash template.
 * @param agents
 * @returns {{}}
 */
function produceAgentObject(agents, threshold) {
    agents = _.compact(agents);
    const num = _.size(agents);
    const returning = {};

    if (num === 0) {
        returning.agentText = i18n._(t`No nPoints`);
    }
    const names = cleanAgents(agents);

    if (num > threshold) {
        returning.agentText = i18n._(t`Selected ${num} nPoint`);
        returning.agentHelpText = names;
        return returning;
    }

    returning.agentText = names;
    return returning;
}

function produceTaggedAgentsObject(tags) {
    return {
        agentText: i18n._(t`Tagged nPoints`),
        agentHelpText: tags.join(', '),
    };
}

/**
 * Format the agents for the tooltip
 * @param agents
 */
function cleanAgents(agents) {
    return _.map(agents, (agent) => escapeHTML(agent.name)).join(', ');
}

function escapeHTML(unsafe) {
    if (unsafe) {
        return unsafe
            .toString()
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    return unsafe;
}
